// extracted by css-extract-rspack-plugin
export default {"container":"container__OFV5_","icon":"icon__qHGnm","success-icon":"success-icon__S6KFP"};